import { BASE_QUERY, ruleNewsPlus } from './shared/configs';

export enum SECTION_ENUM {
  DOW_JONES_RISK_JOURNAL = 'Dow Jones Risk Journal'
}

const BASE = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'Keyword', value: ['risk-compliance'] } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = { ...BASE, count: 2 };

const MAIN = { ...BASE, count: 4 };

const MORE_LIST = { ...BASE };

const AUDIO_PODCAST = {
  ...BASE_QUERY,
  query: {
    and: [
      { term: { key: 'Product', value: 'Dow Jones Risk Journal Audio' } },
      { term: { key: 'ContentType', value: 'audio' } }
    ],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  },
  sort: BASE_QUERY.sort,
  count: BASE_QUERY.count
};

export { MAIN, SECTION_TOP, MORE_LIST, AUDIO_PODCAST };
